import { useState, useEffect } from "react";
import { Row, Col } from "antd";
import InputForm from "./utils/InputForm";
import { AddFetchPais } from "../Api/Administracion/AddFetchPais";
import { PutFetchPais } from "../Api/Administracion/PutFetchPais";

export const AdministrationPaisAddForm = ({ selectedItem, fetchData, setShowModal, modalKey }) => {
  const objDefault = {
    FIPAISID: 0,
    FCNOMBRE: "",
    FIESTATUSID: 1,
  };
  const [formData, setFormData] = useState(objDefault);
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedItem) {
      const newObj = {
        FIPAISID: selectedItem.FIPAISID,
        FCNOMBRE: selectedItem.FCNOMBRE,
        FIESTATUSID: selectedItem.FIESTATUSID,
      };
      setFormData(newObj);
    } else {
      const objDefault = {
        FIPAISID: 0,
        FCNOMBRE: "",
        FIESTATUSID: 1,
      };
      setFormData(objDefault);
    }
  }, [selectedItem, modalKey]);

  useEffect(() => {
    setErrors({});
  }, [selectedItem, modalKey]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "FCNOMBRE" && value.length > 30) {
      setErrors((prevFormData) => ({
        ...prevFormData,
        FCNOMBRE: "El nombre no debe exceder 30 caracteres.",
      }));
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const fetchHandleUpdateCancel = () => {
    setFormData(objDefault);
    setShowModal(false);
  };
  const fetchHandleUpdate = async () => {
    const errors = {};
    if (formData.FCNOMBRE === "") {
      errors.FCNOMBRE = "Ingresa el valor de nombre";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    } else {
      setErrors("");
      sendData();
    }

    function sendData() {
      setLoading(true);
      const onFailure = (error) => {
        //console.log("error", error);
        setLoading(false);
        alert(error);
      };

      const onSuccess = ({ data }) => {
        console.log(data);
        setLoading(false);
        // eslint-disable-next-line no-lone-blocks
        if (data.statusCode === 201) {
          setFormData(objDefault);
          fetchData();
          setShowModal(false);
          alert("Envio exitoso");
        } else {
          alert(data.error);
        }
      };

      if (selectedItem) {
        PutFetchPais(formData).then(onSuccess).catch(onFailure);
      } else {
        AddFetchPais(formData).then(onSuccess).catch(onFailure);
      }
    }
  };
  return (
    <Row justify="space-around">
      <Col span={24}>
        <div className="input-content-titulo">{selectedItem ? "Editar" : "Agregar"} PaÃ­s</div>
      </Col>
      <Col xs={24} md={22}>
        <InputForm
          handleChange={handleChange}
          value={formData.FCNOMBRE}
          name={"FCNOMBRE"}
          type={"text"}
          label={"Nombre"}
        />
        {errors && <div className="error-input-data">{errors.FCNOMBRE}</div>}
      </Col>
      <div className="modal-footer-edith">
        <button
          onClick={fetchHandleUpdateCancel}
          type="submit"
          className="primary-button-cancel button-modal"
        >
          Cancelar
        </button>
        <button
          onClick={fetchHandleUpdate}
          type="submit"
          className={`button-modal ${isLoading ? "primary-button-disable" : "primary-button"}`}
          disabled={isLoading}
        >
          {isLoading ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </Row>
  );
};
